export default "__VITE_ASSET__Y7YTq$nl__"